// src/modules/analytics/utils.ts
import type { LlmUsageStatItem, AnalyticsKpi } from './types';

export function aggregateKpi(items: LlmUsageStatItem[]): AnalyticsKpi {
  if (items.length === 0) {
    return { action_count: 0, tokens_in_total: 0, tokens_out_total: 0, response_time_avg: 0 };
  }

  const totalActions = items.reduce((s, i) => s + i.action_count, 0);
  const tokensIn = items.reduce((s, i) => s + i.tokens_in_total, 0);
  const tokensOut = items.reduce((s, i) => s + i.tokens_out_total, 0);
  const weightedAvg =
    totalActions > 0
      ? items.reduce((s, i) => s + i.response_time_avg * i.action_count, 0) / totalActions
      : 0;

  return {
    action_count: totalActions,
    tokens_in_total: tokensIn,
    tokens_out_total: tokensOut,
    response_time_avg: Math.round(weightedAvg),
  };
}
